import axios from 'axios'
import {createAsyncThunk, PayloadAction, createAction, Action} from '@reduxjs/toolkit'

import { sliceStateStatus } from '../../../../Core';
import {routesIndex} from '@/RoutesIndex';

import ISliceState from '../../../../interface/core/ISliceState';
import IUser from '../../../../interface/core/IUser';

import { generateUserStateDataItem } from '../../../hooks';
import { IType } from '../../../../interface/IType';



export const settingsIndex = createAsyncThunk(
  'settings/index',
  async (_section:string | undefined, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
      }

      let url = routesIndex.api.users.index;

      const q = axios.get(url, config);
      const r = (await q).data;

      return setStateData(r, _section!);

    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const brandsIndex = createAsyncThunk(
  'brands/index',
  async (_, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
      }

      const q = axios.get(routesIndex.api.settings.brands, config);
      const r = (await q).data;

      //return setStateData(r, _section!);

    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
)
export const brandmodelsIndex = createAsyncThunk(
  'brandmodels/index',
  async (_, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
      }

      const q = axios.get(routesIndex.api.settings.brandmodels, config);
      const r = (await q).data;

      //return setStateData(r, _section!);

    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const dictionaryIndex = createAsyncThunk(
  'dictionary/index',
  async (_, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
      }

      const q = axios.get(routesIndex.api.settings.dictionary, config);
      const r = (await q).data;

      return setDictionaryStateData(r);
    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
)



export const settingsReset = createAction('settingsReset')





const setStateData = (apiResponse: any, settingsSection: string|null = null) => {
  const stateData: ISliceState = {
    data: [],
    status: sliceStateStatus.fulfilled
  };

  if (apiResponse.status && apiResponse.result) {
    if (Array.isArray(apiResponse.result)) {

      apiResponse.result.map((a: any, i: number) =>
        stateData.data.push (
          (settingsSection == defaults.settingsSections.users || settingsSection == IType.user) ? generateUserStateDataItem(a)
          : null
        )
      );
      
    } 
  }

  return stateData;
};

const setDictionaryStateData = (apiResponse: any) => {
  const stateData: ISliceState = {
    data: [],
    status: sliceStateStatus.fulfilled
  };

  if (apiResponse.status && apiResponse.result) {
    if (Array.isArray(apiResponse.result)) {


      apiResponse.result.map((a: any, i: number) => {
        
        if (Array.isArray(a)) {
          
          if(a.hasOwnProperty(IType.brand_dictionary)) {

            /*
            a.map((k: IBrandDictionary, ii: number) => {
              brand_dictionary.push(generateBrandDictionaryStateDataItem(a))
            })
            */
           
          }

        }

      }

      );
      
    } 
  }

  return stateData;
};

